declare module '@fluidframework/core-interfaces' {
  export interface IFluidObject extends Readonly<Partial<IProvideHostViewProperties>> {}
}

export interface IProvideHostViewProperties {
  readonly HostViewProperties: HostViewProperties;
}

export interface HostViewProperties extends IProvideHostViewProperties {
  /**
   * Get default config for various components
   * @returns Default configuration in form of `DefaultConfig`
   */
  getViewProperties(): Promise<ViewProperties>;
}

export interface ViewProperties {
  viewType?: ViewType;
}

export enum ViewType {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large'
}
